<template>
  <v-layout>
    <v-card
      contextual-style="dark"
      class="mt-16">
      <span slot="header">
        Login
      </span>
      <div slot="body">
        <form
          ref="loginForm"
          @submit.prevent="login()">
          <fields
            :fields="fields.all()"
            :model="values"
            :errors="errors"
            layout="horizontal"
          />
          <div class="form-group row">
            <div class="col-md-6 offset-md-3 text-center">
              <button
                type="submit"
                class="btn btn-primary">Login</button>
            </div>
          </div>
        </form>
      </div>
    </v-card>
  </v-layout>
</template>

<script>
/* ============
 * Login Index Page
 * ============
 *
 * Page where the user can login.
 */

import { FormMixin } from 'stylemix-base';
import VLayout from '@/layouts/Minimal.vue';
import VCard from '@/components/Card.vue';
import AuthProxy from '@/proxies/AuthProxy';

export default {
  /**
   * The name of the page.
   */
  name: 'LoginIndex',

  /**
   * The components the page can use.
   */
  components: {
    VLayout,
    VCard,
  },

  mixins: [FormMixin],

  /**
   * The data that can be used by the page.
   *
   * @returns {Object} The view-model data.
   */
  data() {
    return {
      values: {
        email: null,
        password: null,
      },
    };
  },

  created() {
    this.setFields([
      {
        attribute: 'email',
        component: 'text-field',
        placeholder: 'user@example.com',
        label: 'Email:',
        type: 'email',
      },
      {
        attribute: 'password',
        component: 'text-field',
        label: 'Password:',
        type: 'password',
      },
    ]);
  },

  /**
   * The methods the page can use.
   */
  methods: {
    /**
     * Will log the user in.
     */
    login() {
      this.withUiBlocker(
        new AuthProxy()
          .login(this.values)
          .then(({ token, expires_in: expiresIn }) => {
            this.$store.dispatch('auth/login', { token, expiresIn }, expiresIn);
          })
          .catch((response) => {
            if (response.status === 422) {
              this.setValidationErrors(response.data.errors);
            }
          }),

          // blockable element
          this.$refs.loginForm
      );
    },
  },
};
</script>
